export default __webpack_public_path__ + "static/mairlin_1-50cdbf14a565d8a078cb3a2b2a32fee6.webp";